import SubmenuWithDoubleTabs from './SubmenuWithDoubleTabs';
import { SubmenuWithDoubleTabsProps, SubmenuWithDoubleTabsValueProps } from './types';

export type { SubmenuWithDoubleTabsProps, SubmenuWithDoubleTabsValueProps };
export default SubmenuWithDoubleTabs;
